"use strict";
/**
 * 素材库管理器
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var MaterialsManager = /** @class */ (function () {
    function MaterialsManager(materials) {
        this.materialsCache = {};
        this.cmpsCache = {};
        this.eventsCache = {};
        this.settingCache = {};
        this.activitiesCache = {};
        this.dataSourceCache = {};
        if (materials) {
            this.addMaterials(materials);
        }
    }
    MaterialsManager.prototype.addMaterials = function (materials) {
        this.materialsCache = __assign(__assign({}, this.materialsCache), materials);
        this.initCmpsCache();
        this.initEventsCache();
        this.initSettingsCache();
        this.initActivitiesCache();
        this.initDataSourceCache();
    };
    /**
     * 初始化cmps缓存数据
     */
    MaterialsManager.prototype.initCmpsCache = function () {
        var cmpsCache = {};
        for (var key in this.materialsCache) {
            var material = this.materialsCache[key];
            cmpsCache[key] = {};
            for (var cmpKey in material.cmps) {
                var cmp = material.cmps[cmpKey];
                if (cmp) {
                    cmpsCache[key][cmp.type] = cmp;
                }
            }
        }
        this.cmpsCache = cmpsCache;
    };
    /**
     * 初始化events缓存数据
     */
    MaterialsManager.prototype.initEventsCache = function () {
        var eventsCache = {};
        for (var key in this.materialsCache) {
            var material = this.materialsCache[key];
            eventsCache[key] = {};
            if (material.events) {
                for (var eventKey in material.events) {
                    var event = material.events[eventKey];
                    eventsCache[key][event.type] = event;
                }
            }
        }
        this.eventsCache = eventsCache;
    };
    /**
     * 初始化 settings 缓存数据
     */
    MaterialsManager.prototype.initSettingsCache = function () {
        var settingsCache = {};
        for (var key in this.materialsCache) {
            var material = this.materialsCache[key];
            settingsCache[key] = {};
            for (var settingKey in material.settings) {
                var setting = material.settings[settingKey];
                settingsCache[key][setting.type] = setting;
            }
        }
        this.settingCache = settingsCache;
    };
    /**
     * 初始化 dataSource 缓存数据
     */
    MaterialsManager.prototype.initDataSourceCache = function () {
        var dataSourceCache = {};
        for (var key in this.materialsCache) {
            var material = this.materialsCache[key];
            dataSourceCache[key] = {};
            for (var dataSourceKey in material.dataSources) {
                var dataSource = material.dataSources[dataSourceKey];
                dataSourceCache[key][dataSource.dataSourceInfo.key] = dataSource;
            }
        }
        this.dataSourceCache = dataSourceCache;
    };
    /**
     * 初始化 activities 缓存数据
     */
    MaterialsManager.prototype.initActivitiesCache = function () {
        var activitiesCache = {};
        for (var key in this.materialsCache) {
            var material = this.materialsCache[key];
            activitiesCache[key] = {};
            for (var activityKey in material.activities) {
                var setting = material.activities[activityKey];
                activitiesCache[key][setting.type] = setting;
            }
        }
        this.activitiesCache = activitiesCache;
    };
    /**
     * 根据id获取素材模块
     * @param id
     */
    MaterialsManager.prototype.getMaterialById = function (id) {
        return this.materialsCache[id];
    };
    /**
     * 获取单个素材组件配置
     * @param materialId
     * @param cmpType
     */
    MaterialsManager.prototype.getCmpConfig = function (materialId, cmpType) {
        return this.cmpsCache[materialId] && this.cmpsCache[materialId][cmpType];
    };
    /**
     * 获取单个事件配置
     * @param materialId
     * @param eventType
     */
    MaterialsManager.prototype.getEventConfig = function (materialId, eventType) {
        return this.eventsCache[materialId] && this.eventsCache[materialId][eventType];
    };
    /**
     * 获取单个全局设置配置
     * @param materialId
     * @param cmpType
     */
    MaterialsManager.prototype.getSettingConfig = function (materialId, settingType) {
        return this.settingCache[materialId] && this.settingCache[materialId][settingType];
    };
    /**
     * 获取单个活动素材配置
     * @param materialId
     * @param activityType
     */
    MaterialsManager.prototype.getActivityConfig = function (materialId, activityType) {
        return this.activitiesCache[materialId] && this.activitiesCache[materialId][activityType];
    };
    /**
     * 获取单个数据源素材配置
     * @param materialId
     * @param dataSourceKey
     */
    MaterialsManager.prototype.getDataSouceConfig = function (materialId, dataSourceKey) {
        return this.dataSourceCache[materialId] && this.dataSourceCache[materialId][dataSourceKey];
    };
    return MaterialsManager;
}());
exports.default = MaterialsManager;
